import { useTranslations } from "@/i18n";
import { Flex } from "@vetty/ui";

import styles from "./MobileAuthNotSupportedBanner.module.scss";

/**
 * MobileAuthNotSupportedBanner Component
 *
 * Desktop-only notice for mobile login or sign-up, with a URL to open on a computer.
 *
 * @returns Mobile restriction banner
 */
export const MobileAuthNotSupportedBanner = ({
  variant,
}: {
  variant: "login" | "sign-up";
}) => {
  // Login-banner copy; sign-up swaps the verb and path
  const t = useTranslations("login.mobileBanner");

  return (
    <>
      {/* Desktop-only notice for the login or sign-up flow */}
      <Flex
        direction={"column"}
        gap={16}
        justify={"center"}
        className={styles["comp"]}
      >
        <h3
          className={styles["comp__heading"]}
          dangerouslySetInnerHTML={{ __html: t.raw("title") }}
        />

        <p className={styles["comp__subtitle"]}>
          {variant === "login"
            ? t("subtitle")
            : t("subtitle").replace("log in", "sign up")}
        </p>

        <div className={styles["comp__url"]}>
          {variant === "login" ? t("url") : t("url").replace("login", "sign-up")}
        </div>
      </Flex>
    </>
  );
};
